import images from "./images";

const testimonials = [
  {
    id: 1,
    image: images.testimonial1,
    name: "John Doe",
    title: "CTO, Tech Innovations",
    content: "Using [Your AI Solution] has been a game changer for our operations. The efficiency and accuracy of the models have exceeded our expectations, making our workflows more streamlined and scalable.",
  },
  {
    id: 2,
    image: images.testimonial2,
    name: "Jane Smith",
    title: "CEO, Digital Solutions",
    content: "The AI-driven analytics we now have access to have transformed the way we approach product development. Our decision-making process has become more data-driven and impactful.",
  },
  {
    id: 3,
    image: images.testimonial3,
    name: "Mark Johnson",
    title: "Head of Engineering, NextGen Systems",
    content: "We've seen a significant increase in operational productivity since adopting this AI platform. It's easy to integrate with our existing systems, and the insights it generates are invaluable for our team.",
  },
  {
    id: 4,
    image: images.testimonial4,
    name: "Sophia Lee",
    title: "VP of Product, InnovateTech",
    content: "This AI platform has allowed us to scale our services more efficiently, provide better user experiences, and unlock valuable insights. The ability to forecast trends and personalize services is unmatched.",
  },
];

export default testimonials;